import type { Maybe } from "~/lib/graphql";

type GenerateEpisodeNumberTitleArgs = {
  episodeNumberName: Maybe<string> | undefined;
  episodeTitle: string;
};

/**
 * ### 話数表記 + 半角スペース + エピソードタイトル形式のタイトルを生成する関数
 * @see https://confl.arms.dmm.com/pages/viewpage.action?pageId=1239450332#id-%E8%A1%A8%E8%A8%98%E3%83%AB%E3%83%BC%E3%83%AB/%E3%82%BF%E3%82%A4%E3%83%88%E3%83%AB-%E8%A9%B1%E6%95%B0%E8%A1%A8%E8%A8%98%20%E3%82%A8%E3%83%94%E3%82%BD%E3%83%BC%E3%83%89%E3%82%BF%E3%82%A4%E3%83%88%E3%83%AB
 */
export const generateEpisodeNumberTitle = (args: GenerateEpisodeNumberTitleArgs) => {
  const { episodeNumberName, episodeTitle } = args;

  if (episodeNumberName === null || episodeNumberName === undefined) return episodeTitle;
  return episodeNumberName === episodeTitle ? episodeTitle : `${episodeNumberName} ${episodeTitle}`;
};
